(() => {
  const section = document.querySelector('#customer-reviews');
  const widget = section?.querySelector('loox-dynamic-carousel-widget');
  const button = section?.querySelector('.se-reviews__playback');
  if (!widget || !button || section.dataset.motionReady) return;
  section.dataset.motionReady = 'true';

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduced.matches;
  let visible = false;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');

  const sync = () => {
    const interacting = widget.matches(':focus-within') || (finePointer.matches && widget.matches(':hover'));
    const playing = visible && !paused && !interacting && !document.hidden;
    const driver = widget.shadowRoot?.querySelector('.image-swiper')?.swiper;
    if (driver?.autoplay && driver.autoplay.running !== playing) {
      driver.autoplay[playing ? 'start' : 'stop']();
    }
    widget.dataset.playing = String(playing);
    button.setAttribute('aria-pressed', String(paused));
    button.querySelector('span').textContent = paused ? button.dataset.resumeLabel : button.dataset.pauseLabel;
  };
  button.addEventListener('click', () => { paused = !paused; sync(); });
  widget.addEventListener('pointerenter', sync);
  widget.addEventListener('pointerleave', sync);
  widget.addEventListener('focusin', sync);
  widget.addEventListener('focusout', () => queueMicrotask(sync));
  document.addEventListener('visibilitychange', sync);
  reduced.addEventListener('change', e => { paused = e.matches; sync(); });
  new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: 0.2 }).observe(widget);
  section.querySelector('.se-reviews__controls').hidden = false;
  sync();

  // Loox encapsulates its copy in an open shadow root. Scope the type adjustment
  // to this widget, leaving Loox review content and other store widgets intact.
  customElements.whenDefined('loox-dynamic-carousel-widget').then(() => {
    const root = widget.shadowRoot;
    if (!root) return;
    const style = document.createElement('style');
    style.dataset.seReviewType = '';
    style.textContent = `
      .loox-dynamic-carousel-widget .review-text {
        --loox-u-dynamic-carousel-review-font-size: 18px !important;
        --loox-u-dynamic-carousel-review-line-height: 1.55 !important;
        --loox-u-dynamic-carousel-review-max-lines: 8 !important;
        font-weight: 400; letter-spacing: 0; text-wrap: pretty;
      }
      .loox-dynamic-carousel-widget .reviewer-name-container { font-size: 14px; }
      @media(max-width:720px) {
        .loox-dynamic-carousel-widget .review-text {
          --loox-u-dynamic-carousel-review-font-size: 16px !important;
          --loox-u-dynamic-carousel-review-line-height: 1.5 !important;
          --loox-u-dynamic-carousel-review-max-lines: 5 !important;
        }
        .loox-dynamic-carousel-widget .reviewer-name-container { font-size: 13px; }
      }`;
    const apply = () => {
      if (!root.querySelector('[data-se-review-type]')) root.append(style);
      sync();
    };
    apply();
    new MutationObserver(apply).observe(root, { childList: true, subtree: true });
  });
})();
